import React, { useContext, useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import { GlobalState } from '../../../../GlobalState';
import { TabTitle } from '../../../../util/titleChanger'
import { api } from '../../../../util/urlConfig';
import './customerview.css'

function CustomerView() {
    TabTitle('View Customer')

    const { customerId } = useParams();
    const state = useContext(GlobalState);

    const [customerDetail] = state.customerAPI.customerDetail;
    const [users] = state.userAPI.users;
    const [id, setId] = state.customerAPI.id;

    const [values, setValues] = useState('')

    useEffect(() => {
        if (customerId > 0) {
            setId(customerId);
            var today = new Date();
            var dob = new Date(customerDetail.dob);
            var createAt = new Date(customerDetail.created_at);
            var createBy = users.data && customerDetail.created_by ? users.data.find(user => {
                return user.nic === customerDetail.created_by.nic
            }) : ""

            setValues({
                ...values,
                customer_code: customerDetail.customer_code ? customerDetail.customer_code : "",
                first_name: customerDetail.first_name ? customerDetail.first_name : "",
                last_name: customerDetail.last_name ? customerDetail.last_name : "",
                contact_no: customerDetail.contact_no ? customerDetail.contact_no : "",
                dob: customerDetail.dob ? dob.toLocaleDateString('ja-JP') : today.toLocaleDateString('ja-JP'),
                nic: customerDetail.nic ? customerDetail.nic : "",
                email: customerDetail.email ? customerDetail.email : "",
                address1: customerDetail.address1 ? customerDetail.address1 : "",
                address2: customerDetail.address2 ? customerDetail.address2 : "",
                address3: customerDetail.address3 ? customerDetail.address3 : "",
                village: customerDetail.village ? customerDetail.village : "",
                city: customerDetail.city ? customerDetail.city : "",
                country: customerDetail.country ? customerDetail.country : "",
                created_at: customerDetail.created_at ? createAt.toLocaleDateString('ja-JP') : today.toLocaleDateString('ja-JP'),
                created_by: customerDetail.created_by ? createBy : { first_name: "", last_name: "" },
                image_url: customerDetail.upload_image ? customerDetail.upload_image.image_url : '/img/dummy_avatar.png'
            })
        }
    }, [id, customerId, customerDetail])

    return (
        <div className="profile-main-container">
            <div className="profile-container">
                <div className="left-container">
                    <img src={api + "/" + values.image_url} alt="avatar" />
                </div>
                <div className='right-container'>
                    <div className="action">
                        <Link to={`/customer-form/${id}`}><i className="uil uil-pen"></i><button></button></Link>
                    </div>
                    <div className="name-title">
                        <h2>{values.first_name + " " + values.last_name}</h2>
                        <p>{values.customer_code}</p>
                    </div>
                    <div className="user-content">
                        <p>DOB : <span>{values.dob}</span></p>
                        <p>Email : <span>{values.email}</span></p>
                        <p className='status'>Created By : <span>{values.created_by ? values.created_by.first_name : ""} {values.created_by ? values.created_by.last_name : ""}</span></p>
                        <p>NIC : <span>{values.nic}</span></p>
                        <p>Contact No : <span>{values.contact_no}</span></p>
                        <p>Created At : <span>{values.created_at}</span></p>
                        <p>Address : <span>{values.address1 + ", " + values.address2 + ", " + values.address3 + ", "}<br />
                            {values.village + ", " + values.city}</span></p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CustomerView